import { render } from "./json-builder-actions.vue?vue&type=template&id=3f0bad8a&scoped=true"
import script from "./json-builder-actions.vue?vue&type=script&lang=js"
export * from "./json-builder-actions.vue?vue&type=script&lang=js"

import "./json-builder-actions.vue?vue&type=style&index=0&id=3f0bad8a&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f0bad8a"]])

export default __exports__